import type { ButtonHTMLAttributes, ReactNode } from "react";

interface GreenButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  icon?: ReactNode;
}

export default function GreenButton({
  children,
  icon,
  className = "",
  ...props
}: GreenButtonProps) {
  const baseClasses =
    "inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer";
  const greenClasses =
    "bg-primary-500 hover:bg-primary-400 text-gray-900 border-none px-4 py-2 text-sm w-full";

  return (
    <button
      className={`${baseClasses} ${greenClasses} ${className}`}
      {...props}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
}
